// cspell: disable
export const userTranslations = {
  'en-GB': {
    user: {
      profile: {
        title: 'User Profile',
        userInfo: 'User Profile',
        changePassword: 'Change Password',
        displayName: 'Display Name',
        avatar: 'Profile Picture',
        availableCourses: 'Available Courses',
        buttons: {
          logout: 'Logout',
          close: 'Close',
          changePassword: 'Change Password',
          save: 'Save',
          cancel: 'Cancel',
          edit: 'Edit',
          removeAvatar: 'Remove Avatar'
        },
        form: {
          currentPassword: 'Current Password',
          newPassword: 'New Password',
          confirmNewPassword: 'Confirm New Password',
          placeholders: {
            currentPassword: 'Enter current password',
            newPassword: 'Enter new password',
            confirmNewPassword: 'Confirm new password',
            displayName: 'Enter display name'
          }
        },
        validation: {
          fillAllFields: 'Please fill in all password fields',
          passwordsDoNotMatch: 'New passwords do not match',
          passwordTooShort: 'New password must be at least 6 characters long',
          userNotAuthenticated: 'User not authenticated'
        },
        messages: {
          passwordChanged: 'Password changed successfully!',
          displayNameUpdated: 'Display name updated successfully',
          loggedOut: 'Logged out successfully',
          logoutFailed: 'Failed to logout',
          updateFailed: 'Failed to update display name',
          networkError: 'Please check your internet connection and try again',
          wrongPassword: 'Current password is incorrect',
          weakPassword: 'New password is too weak',
          requiresRecentLogin: 'Please log out and log back in before changing your password',
          userDisabled: 'This user account has been disabled',
          avatarUploadFailed: 'Failed to upload avatar. Please check your connection and try again',
          avatarRemoveFailed: 'Failed to remove avatar. Please check your connection and try again',
          avatarFileTooLarge: 'Avatar image must be smaller than 2MB',
          avatarInvalidType: 'Avatar must be a JPEG, PNG, GIF, or WebP image'
        }
      }
    }
  },
  'en-US': {
    user: {
      profile: {
        title: 'User Profile',
        userInfo: 'User Profile',
        changePassword: 'Change Password',
        displayName: 'Display Name',
        avatar: 'Profile Picture',
        availableCourses: 'Available Courses',
        buttons: {
          logout: 'Logout',
          close: 'Close',
          changePassword: 'Change Password',
          save: 'Save',
          cancel: 'Cancel',
          edit: 'Edit',
          removeAvatar: 'Remove Avatar'
        },
        form: {
          currentPassword: 'Current Password',
          newPassword: 'New Password',
          confirmNewPassword: 'Confirm New Password',
          placeholders: {
            currentPassword: 'Enter current password',
            newPassword: 'Enter new password',
            confirmNewPassword: 'Confirm new password',
            displayName: 'Enter display name'
          }
        },
        validation: {
          fillAllFields: 'Please fill in all password fields',
          passwordsDoNotMatch: 'New passwords do not match',
          passwordTooShort: 'New password must be at least 6 characters long',
          userNotAuthenticated: 'User not authenticated'
        },
        messages: {
          passwordChanged: 'Password changed successfully!',
          displayNameUpdated: 'Display name updated successfully',
          loggedOut: 'Logged out successfully',
          logoutFailed: 'Failed to logout',
          updateFailed: 'Failed to update display name',
          networkError: 'Please check your internet connection and try again',
          wrongPassword: 'Current password is incorrect',
          weakPassword: 'New password is too weak',
          requiresRecentLogin: 'Please log out and log back in before changing your password',
          userDisabled: 'This user account has been disabled',
          avatarUploadFailed: 'Failed to upload avatar. Please check your connection and try again',
          avatarRemoveFailed: 'Failed to remove avatar. Please check your connection and try again',
          avatarFileTooLarge: 'Avatar image must be smaller than 2MB',
          avatarInvalidType: 'Avatar must be a JPEG, PNG, GIF, or WebP image'
        }
      }
    }
  },
  de: {
    user: {
      profile: {
        title: 'Benutzerprofil',
        userInfo: 'Benutzerprofil',
        changePassword: 'Passwort ändern',
        displayName: 'Anzeigename',
        avatar: 'Profilbild',
        availableCourses: 'Verfügbare Kurse',
        buttons: {
          logout: 'Abmelden',
          close: 'Schließen',
          changePassword: 'Passwort ändern',
          save: 'Speichern',
          cancel: 'Abbrechen',
          edit: 'Bearbeiten',
          removeAvatar: 'Avatar entfernen'
        },
        form: {
          currentPassword: 'Aktuelles Passwort',
          newPassword: 'Neues Passwort',
          confirmNewPassword: 'Neues Passwort bestätigen',
          placeholders: {
            currentPassword: 'Aktuelles Passwort eingeben',
            newPassword: 'Neues Passwort eingeben',
            confirmNewPassword: 'Neues Passwort bestätigen',
            displayName: 'Anzeigenamen eingeben'
          }
        },
        validation: {
          fillAllFields: 'Bitte füllen Sie alle Passwortfelder aus',
          passwordsDoNotMatch: 'Neue Passwörter stimmen nicht überein',
          passwordTooShort: 'Das neue Passwort muss mindestens 6 Zeichen lang sein',
          userNotAuthenticated: 'Benutzer nicht authentifiziert'
        },
        messages: {
          passwordChanged: 'Passwort erfolgreich geändert!',
          displayNameUpdated: 'Anzeigename erfolgreich aktualisiert',
          loggedOut: 'Erfolgreich abgemeldet',
          logoutFailed: 'Abmeldung fehlgeschlagen',
          updateFailed: 'Anzeigename konnte nicht aktualisiert werden',
          networkError: 'Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut',
          wrongPassword: 'Aktuelles Passwort ist falsch',
          weakPassword: 'Neues Passwort ist zu schwach',
          requiresRecentLogin: 'Bitte melden Sie sich ab und wieder an, bevor Sie Ihr Passwort ändern',
          userDisabled: 'Dieses Benutzerkonto wurde deaktiviert',
          avatarUploadFailed: 'Avatar konnte nicht hochgeladen werden. Bitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut',
          avatarRemoveFailed: 'Avatar konnte nicht entfernt werden. Bitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut',
          avatarFileTooLarge: 'Avatar-Bild muss kleiner als 2MB sein',
          avatarInvalidType: 'Avatar muss ein JPEG-, PNG-, GIF- oder WebP-Bild sein'
        }
      }
    }
  },
  fr: {
    user: {
      profile: {
        title: 'Profil utilisateur',
        userInfo: 'Profil utilisateur',
        changePassword: 'Changer le mot de passe',
        displayName: 'Nom d\'affichage',
        avatar: 'Photo de profil',
        availableCourses: 'Cours disponibles',
        buttons: {
          logout: 'Déconnexion',
          close: 'Fermer',
          changePassword: 'Changer le mot de passe',
          save: 'Enregistrer',
          cancel: 'Annuler',
          edit: 'Modifier',
          removeAvatar: 'Supprimer l\'avatar'
        },
        form: {
          currentPassword: 'Mot de passe actuel',
          newPassword: 'Nouveau mot de passe',
          confirmNewPassword: 'Confirmer le nouveau mot de passe',
          placeholders: {
            currentPassword: 'Entrez le mot de passe actuel',
            newPassword: 'Entrez le nouveau mot de passe',
            confirmNewPassword: 'Confirmez le nouveau mot de passe',
            displayName: 'Entrez le nom d\'affichage'
          }
        },
        validation: {
          fillAllFields: 'Veuillez remplir tous les champs de mot de passe',
          passwordsDoNotMatch: 'Les nouveaux mots de passe ne correspondent pas',
          passwordTooShort: 'Le nouveau mot de passe doit contenir au moins 6 caractères',
          userNotAuthenticated: 'Utilisateur non authentifié'
        },
        messages: {
          passwordChanged: 'Mot de passe changé avec succès !',
          displayNameUpdated: 'Nom d\'affichage mis à jour avec succès',
          loggedOut: 'Déconnexion réussie',
          logoutFailed: 'Échec de la déconnexion',
          updateFailed: 'Échec de la mise à jour du nom d\'affichage',
          networkError: 'Veuillez vérifier votre connexion Internet et réessayer',
          wrongPassword: 'Le mot de passe actuel est incorrect',
          weakPassword: 'Le nouveau mot de passe est trop faible',
          requiresRecentLogin: 'Veuillez vous déconnecter et vous reconnecter avant de changer votre mot de passe',
          userDisabled: 'Ce compte utilisateur a été désactivé',
          avatarUploadFailed: 'Échec du téléchargement de l\'avatar. Veuillez vérifier votre connexion et réessayer',
          avatarRemoveFailed: 'Échec de la suppression de l\'avatar. Veuillez vérifier votre connexion et réessayer',
          avatarFileTooLarge: 'L\'image de l\'avatar doit être inférieure à 2MB',
          avatarInvalidType: 'L\'avatar doit être une image JPEG, PNG, GIF ou WebP'
        }
      }
    }
  },
  it: {
    user: {
      profile: {
        title: 'Profilo utente',
        userInfo: 'Profilo utente',
        changePassword: 'Cambia password',
        displayName: 'Nome visualizzato',
        avatar: 'Foto profilo',
        availableCourses: 'Corsi disponibili',
        buttons: {
          logout: 'Disconnetti',
          close: 'Chiudi',
          changePassword: 'Cambia password',
          save: 'Salva',
          cancel: 'Annulla',
          edit: 'Modifica',
          removeAvatar: 'Rimuovi avatar'
        },
        form: {
          currentPassword: 'Password attuale',
          newPassword: 'Nuova password',
          confirmNewPassword: 'Conferma nuova password',
          placeholders: {
            currentPassword: 'Inserisci la password attuale',
            newPassword: 'Inserisci la nuova password',
            confirmNewPassword: 'Conferma la nuova password',
            displayName: 'Inserisci il nome visualizzato'
          }
        },
        validation: {
          fillAllFields: 'Si prega di compilare tutti i campi della password',
          passwordsDoNotMatch: 'Le nuove password non corrispondono',
          passwordTooShort: 'La nuova password deve essere lunga almeno 6 caratteri',
          userNotAuthenticated: 'Utente non autenticato'
        },
        messages: {
          passwordChanged: 'Password cambiata con successo!',
          displayNameUpdated: 'Nome visualizzato aggiornato con successo',
          loggedOut: 'Disconnessione riuscita',
          logoutFailed: 'Disconnessione fallita',
          updateFailed: 'Impossibile aggiornare il nome visualizzato',
          networkError: 'Verificare la connessione Internet e riprovare',
          wrongPassword: 'La password attuale non è corretta',
          weakPassword: 'La nuova password è troppo debole',
          requiresRecentLogin: 'Si prega di disconnettersi e accedere di nuovo prima di cambiare la password',
          userDisabled: 'Questo account utente è stato disabilitato',
          avatarUploadFailed: 'Impossibile caricare l\'avatar. Verificare la connessione e riprovare',
          avatarRemoveFailed: 'Impossibile rimuovere l\'avatar. Verificare la connessione e riprovare',
          avatarFileTooLarge: 'L\'immagine dell\'avatar deve essere inferiore a 2MB',
          avatarInvalidType: 'L\'avatar deve essere un\'immagine JPEG, PNG, GIF o WebP'
        }
      }
    }
  },
  es: {
    user: {
      profile: {
        title: 'Perfil de usuario',
        userInfo: 'Perfil de usuario',
        changePassword: 'Cambiar contraseña',
        displayName: 'Nombre para mostrar',
        avatar: 'Foto de perfil',
        availableCourses: 'Cursos disponibles',
        buttons: {
          logout: 'Cerrar sesión',
          close: 'Cerrar',
          changePassword: 'Cambiar contraseña',
          save: 'Guardar',
          cancel: 'Cancelar',
          edit: 'Editar',
          removeAvatar: 'Eliminar avatar'
        },
        form: {
          currentPassword: 'Contraseña actual',
          newPassword: 'Nueva contraseña',
          confirmNewPassword: 'Confirmar nueva contraseña',
          placeholders: {
            currentPassword: 'Ingresa la contraseña actual',
            newPassword: 'Ingresa la nueva contraseña',
            confirmNewPassword: 'Confirma la nueva contraseña',
            displayName: 'Ingresa el nombre para mostrar'
          }
        },
        validation: {
          fillAllFields: 'Por favor completa todos los campos de contraseña',
          passwordsDoNotMatch: 'Las nuevas contraseñas no coinciden',
          passwordTooShort: 'La nueva contraseña debe tener al menos 6 caracteres',
          userNotAuthenticated: 'Usuario no autenticado'
        },
        messages: {
          passwordChanged: '¡Contraseña cambiada exitosamente!',
          displayNameUpdated: 'Nombre para mostrar actualizado exitosamente',
          loggedOut: 'Sesión cerrada exitosamente',
          logoutFailed: 'Error al cerrar sesión',
          updateFailed: 'Error al actualizar el nombre para mostrar',
          networkError: 'Por favor, verifica tu conexión a Internet e intenta de nuevo',
          wrongPassword: 'La contraseña actual es incorrecta',
          weakPassword: 'La nueva contraseña es demasiado débil',
          requiresRecentLogin: 'Por favor, cierra la sesión e inicia sesión nuevamente antes de cambiar tu contraseña',
          userDisabled: 'Esta cuenta de usuario ha sido deshabilitada',
          avatarUploadFailed: 'Error al cargar el avatar. Por favor, verifica tu conexión e intenta de nuevo',
          avatarRemoveFailed: 'Error al eliminar el avatar. Por favor, verifica tu conexión e intenta de nuevo',
          avatarFileTooLarge: 'La imagen del avatar debe ser menor que 2MB',
          avatarInvalidType: 'El avatar debe ser una imagen JPEG, PNG, GIF o WebP'
        }
      }
    }
  }
}